<h5 class="mt-2 mb-4 ms-2">Limite Adicional por Cestas para Operações de Repasse</h5>

<section class="limite-af">
  <div class="container">

    <div class="mb-3 row">
      <div class="col">
        <h3>{{ modo === 'cadastro' ? 'Cadastrar' : 'Editar' }} Valor Limite por Agente Financeiro</h3>
      </div>

      <div class="col-auto">
        <button
          type="button"
          class="btn btn-danger me-2"
          (click)="fechar()">
          Fechar
        </button>

        <button
          type="button"
          class="btn btn-success no-margin"
          [disabled]="!podeSalvar"
          (click)="salvar()">
          Salvar
        </button>
      </div>
    </div>

    <div class="mb-3 row">
      <div class="col-md-5 bn-form-group">
        <label for="agenteFinanceiro">Agente Financeiro <span class="text-danger">*</span></label>
        <select id="agenteFinanceiro" class="form-select" [(ngModel)]="idAgenteFinanceiro" (change)="onAgenteSelecionado()">
          <option [ngValue]="null"></option>
          <option [ngValue]="af.id" *ngFor="let af of agentesFinanceiros">{{ af.descricao }}</option>
        </select>
      </div>
    </div>

    <div class="row">
      <div class="col-md-5 bn-form-group">
        <label for="limiteAdicional">Limite Adicional <span class="text-danger">*</span></label>
        <select id="limiteAdicional" class="form-select" [(ngModel)]="idLimiteAdicional"
          (change)="onLimiteSelecionado()" [disabled]="modo === 'edicao' && !idAgenteFinanceiro">
          <option [ngValue]="null"></option>
          <option [ngValue]="la.id" *ngFor="let la of limitesAdicionaisOpcoes">{{ la.descricao }}</option>
        </select>
      </div>

      <div class="col-md-2 bn-form-group" *ngIf="exibeValorLimite">
        <label for="valorLimite">Valor do Limite <span class="text-danger">*</span></label>
        <input id="valorLimite" type="text" inputmode="numeric" class="form-control"
          [ngModel]="valorLimiteMascara" (input)="onValorInput($event)" placeholder="R$ 0,00">
      </div>
    </div>
  </div>
</section>